import React from 'react';
import GlobalModal from './modal';
import { ButtonComponent } from '../form/elements/button';
import { useTranslation } from 'react-i18next';

interface Props {
  message: string;
  onClose: () => void;
}

export default function MessageModal({ message, onClose }: Props) {
  const { t } = useTranslation();

  return (
    <GlobalModal
      visible={true}
      onClose={onClose}
      body={message}
      buttons={
        <ButtonComponent
          name="ok"
          label={t('common.ok')}
          click={() => onClose()}
        />
      }
    />
  );
}
